<template>
  <div v-if="!loader">
    <v-btn
      @click="createDialog = true"
      x-large
      class="ma-6 pa-2 rounded-xl"
      color="primary"
    >
      {{ $t("add semester") }}<v-icon class="ma-1">mdi-plus</v-icon>
    </v-btn>
    <create
      @createData="create"
      @closePopup="createDialog = false"
      :dialog="createDialog"
      :loader="craeteLoader"
    />
    <edit
      @editData="edit"
      @closePopup="editDialog = false"
      :dialog="editDialog"
      :orginalData="editData"
      :loader="editLoader"
    />
    <delete-popup
      @deleteData="deleteItem($event)"
      @closePopup="deleteDialog = false"
      :dialog="deleteDialog"
      :loader="deleteLoader"
      :item="deleteData"
    />
    <v-row>
      <v-col>
        <v-row>
          <v-col
            v-for="(item, i) in semesters"
            :key="i"
            lg="6"
            md="3"
            sm="6"
            cols="12"
          >
            <card
              @clicked="$emit('openSemester', $event)"
              :icon="'mdi-book-open'"
              :item="item"
              :editAble="editAble"
              :deleteAble="deleteAble"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
  <pulse-loader
    v-else
    :loading="true"
    :color="$vuetify.theme.themes.light.primary"
    size="20px"
  />
</template>
<script>
import { Semester } from "@/store/common/semester";
import card from "../../card.vue";
import create from "./create.vue";
import edit from "./edit.vue";
export default {
  props: ["id"],
  components: {
    create,
    edit,
    card,
  },
  data() {
    return {
      Semester,
      createDialog: false,
      editDialog: false,
      editData: null,
      deleteDialog: false,
      deleteData: null,
      mixinTest: "yes test",
    };
  },
  methods: {
    //create
    async create(data) {
      let payload = {
        name: data.name,
        school_id: this.id,
      };
      await this.name.post(payload);
      this.createDialog = false;
      this.name.get({ school_id: this.id });
    },

    //edit
    editAble(data) {
      this.editData = data;
      this.editDialog = true;
    },
    async edit(data) {
      await this.name.edit(data.data, data.id);
      this.editDialog = false;
      this.name.get({ school_id: this.id });
    },

    //delete
    deleteAble(data) {
      this.deleteData = data;
      this.deleteDialog = true;
    },
    async deleteItem(id) {
      await this.name.deleteItem(id);
      this.deleteDialog = false;
      this.name.get({ school_id: this.id });
    },
  },
  computed: {
    name() {
      return Semester;
    },
    semesters() {
      return this.name.tableData.data;
    },

    //loaders
    loader() {
      return this.name.getState.loading;
    },
    craeteLoader() {
      return this.name.postState.loading;
    },
    editLoader() {
      return this.name.editState.loading;
    },
    deleteLoader() {
      return this.name.deleteState.loading;
    },
  },
  created() {
    this.name.get({ school_id: this.id });
  },
};
</script>
